import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classNames from 'classnames';
import { getAllMacroCategories } from '@sbt-web/category-utils';
import { CategoryID } from '@sbt-web/network/types';
import { ToggleDetails } from '@/client/components/Search/Elements/ToggleDetails';
import { adTypesToSlugMap } from '@/shared/tools/search/values';
import ownClasses from './Sitemap.module.scss';
const macrosToShow = getAllMacroCategories().filter(macro => macro.id !== CategoryID.Altri && macro.id !== CategoryID.Tutte);
const categoryLists = macrosToShow.map(macro => <div key={macro.id} className={ownClasses.macro}>
    <p className={classNames('subheading', 'small', ownClasses.title, ownClasses.capitalize, ownClasses['category-name'])}>
      <a href={`/annunci-italia/vendita/${macro.friendly}/`}>
        {macro.label.toLowerCase()}
      </a>
    </p>

    <ol className={ownClasses['sub-list']}>
      {macro.categories.map(category => <li key={category.id} className={ownClasses['category']}>
          <p className={classNames('body-text', 'book', 'small', ownClasses['category-name'])}>
            <a href={`/annunci-italia/${adTypesToSlugMap[category.defaultAdType]}/${category.friendly}/`}>
              {category.label}
            </a>
          </p>
        </li>)}
    </ol>
  </div>);
const Sitemap: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2>Tutte le categorie</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section data-google-interstitial="false"><ToggleDetails summary={t0} className={ownClasses.container}><div className={ownClasses["categories-list"]}>{categoryLists}</div></ToggleDetails></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Sitemap;